import { render, staticRenderFns } from "./AppointmentsRequestsPerDate.vue?vue&type=template&id=5fc04c2a&scoped=true&"
import script from "./AppointmentsRequestsPerDate.vue?vue&type=script&lang=js&"
export * from "./AppointmentsRequestsPerDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc04c2a",
  null
  
)

export default component.exports